export default __webpack_public_path__ + "static/media/ic_check_circle.c85e8cbc.svg";